import React, { useEffect, useState } from "react";
import styles from "./Body.module.css";

const Body = ({children}) => {
    return (
        <div className={styles.Body}>
            { children ? children : '' }
        </div>
    );
}

export default Body;